module.exports = __webpack_public_path__ + "static/media/crash.7b97fa34.svg";